export default "__VITE_ASSET__3833edf7__"